export default __webpack_public_path__ + "static/media/delete-icon.78ed6ff7.svg";